import { render, staticRenderFns } from "./TagPillBundler.vue?vue&type=template&id=3c4550de"
import script from "./TagPillBundler.vue?vue&type=script&lang=ts"
export * from "./TagPillBundler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports